import {
  createRootRoute,
  createRoute,
  Outlet,
  redirect,
} from '@tanstack/react-router'
import { getSession } from './lib/supabase'
import { LoginPage } from './routes/login'
import { AuthCallbackPage } from './routes/auth/callback'
import { DashboardPage } from './routes/index'
import { ItemDetailPage } from './routes/items.$itemId'
import { SearchPage } from './routes/search'
import { IngestPage } from './routes/ingest'
import { ArchivePage } from './routes/archive'
import { TagsPage } from './routes/tags'
import { ChatsPage } from './routes/chats'
import { ChatPage } from './routes/chat'
import { NewsPage } from './routes/news'

const rootRoute = createRootRoute({
  beforeLoad: async ({ location }) => {
    const publicPaths = ['/login', '/auth/callback']
    if (publicPaths.includes(location.pathname)) return
    const session = await getSession()
    if (!session) throw redirect({ to: '/login' })
  },
  component: () => <Outlet />,
})

const loginRoute        = createRoute({ getParentRoute: () => rootRoute, path: '/login',             component: LoginPage })
const authCallbackRoute = createRoute({ getParentRoute: () => rootRoute, path: '/auth/callback',     component: AuthCallbackPage })
const indexRoute        = createRoute({ getParentRoute: () => rootRoute, path: '/',                  component: DashboardPage })
const itemDetailRoute   = createRoute({ getParentRoute: () => rootRoute, path: '/items/$itemId',     component: ItemDetailPage })
const searchRoute       = createRoute({ getParentRoute: () => rootRoute, path: '/search',            component: SearchPage })
const ingestRoute       = createRoute({ getParentRoute: () => rootRoute, path: '/ingest',            component: IngestPage })
const archiveRoute      = createRoute({ getParentRoute: () => rootRoute, path: '/archive',           component: ArchivePage })
const tagsRoute         = createRoute({ getParentRoute: () => rootRoute, path: '/tags',              component: TagsPage })
const chatsRoute        = createRoute({ getParentRoute: () => rootRoute, path: '/chats',             component: ChatsPage })
const chatRoute         = createRoute({ getParentRoute: () => rootRoute, path: '/chat',              component: ChatPage })
const newsRoute         = createRoute({ getParentRoute: () => rootRoute, path: '/news',              component: NewsPage })

export const routeTree = rootRoute.addChildren([
  loginRoute,
  authCallbackRoute,
  indexRoute,
  itemDetailRoute,
  searchRoute,
  ingestRoute,
  archiveRoute,
  tagsRoute,
  chatsRoute,
  chatRoute,
  newsRoute,
])
